import { Component, OnInit, ViewChild } from '@angular/core';
import { LoginService } from 'src/app/components/Shared/Service/login_service';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import {ToastrService} from 'ngx-toastr'
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatSelectChange, MatTableDataSource } from '@angular/material';
import { IdsProductsService } from '../Shared/Service/ids-products.service';
import beautify from 'xml-beautifier';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export class idsProductList {
    id: number;
    status: String;
    hotelName: String;
    accountingDate: any;
    pusheddate: any;
    type:any
}

@Component({
  selector: 'app-qatar-upload',
  templateUrl: './qatar-upload.component.html',
  styleUrls: ['./qatar-upload.component.css','../commonStyle.css'],
  providers: [LoginService, IdsProductsService,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class QatarUploadComponent implements OnInit {
  display: Boolean = false;
  typ:any;
  pageSize = 50;
  url: string
  defaultData: any;
  errorMsgSubscription: boolean;
  errorMessage: string;
  displayContent: boolean;
  displayErrorContent:boolean
  statusResult: string;
  XMLstatus: any;
  XMLName: string;
  filterProperty: any;
  pmscode: any;
  pmsname: any;
  blinkOfflineHotel: boolean;
  currentDateStore: any;
  storeHeartBeatValue: any;
  dt1: any;
  dt2: any;
  beforeConversion: any;
  constructor(private datePipe: DatePipe,private apiCallForIdsProductsService: IdsProductsService,private toastr: ToastrService, public loginService: LoginService) { }
  today = new Date();
  totalcount: any = 0;
  public idsProductList: idsProductList[];
  dataSource: MatTableDataSource<idsProductList>
  dataSource1: MatTableDataSource<idsProductList>
  StorelstRestr: any;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  Val: string;
  selectedProperty: string;
  UID:any;
  selectedChannel: any;
  selectedDate: any = new Date();
  selectedTOODate: any = new Date();
  isProgressing: Boolean = false;
  public Pmscodevalue: any;
  Userid: any = [];
  displayedColumns1: string[] = ['status','res','resSrl','reg', 'guestName', 'pusheddate', 'type','request_JSON','response_JSON'];

  displayedColumns: string[] = ['hotelName','heartbeat','resDateTime','checkIn','checkOut','error'];
  dropdownSettingsDept: IDropdownSettings = {};
  selectedDeptItems:any;
  dropdownDeptData: any;
  checkTodayDate:any
  CurrentDate = new Date();
  ngOnInit() {
    this.checkTodayDate = this.CurrentDate.getDate()
    console.log('check Today =', this.checkTodayDate)
    this.isProgressing = true;
    this.errorMsgSubscription = true
    this.errorMessage = "Loading......."
    this.displayContent = false
    this.displayErrorContent = false
    this.statusResult = "Not Sent"
    this.callIDSUsersProperties();

    this.dropdownSettingsDept = {
      idField: 'propertyCode',
      textField: 'propertyName',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Hotel Code / Name"
    };
  }

  GetHeartbeatDateTime(heartBeatData:any) {
    console.log('GetHeartbeatDateTime call',heartBeatData)
    this.beforeConversion = heartBeatData
    this.storeHeartBeatValue = this.datePipe.transform(heartBeatData, 'yyyy-MM-dd HH:mm:ss');
    console.log('storeHeartBeatValue 1st= ',this.storeHeartBeatValue);
    this.currentDateStore = this.datePipe.transform(this.today, 'yyyy-MM-dd HH:mm:ss');
    console.log('currentDateStore 1st= ',this.currentDateStore);
    this.dt1 = new Date(this.storeHeartBeatValue);
    this.dt2 = new Date(this.currentDateStore);
    console.log('diff_minutes = ',this.diff_minutes(this.dt2, this.dt1));
    if(this.diff_minutes(this.dt2, this.dt1) > 30){
      console.log('blinkOfflineHotel true')
      this.blinkOfflineHotel = true
      return this.beforeConversion
    }else{
      console.log('blinkOfflineHotel false')
      this.blinkOfflineHotel = false
      return this.beforeConversion
    }
// For blinking the record
// const today = new Date()
//         console.log('Today Date = ',today);
//         this.currentDateStore = today.toLocaleTimeString('it-IT')
//         console.log('Today Date = ',this.currentDateStore);
//         this.storeHeartBeatValue = this.GetHeartbeatTime(heartBeatData)
// // this.storeHeartBeatValue = heartBeatData
// var start = this.storeHeartBeatValue.split(":");
// var end = this.currentDateStore.split(":");
// var startDate = new Date(0, 0, 0, start[1], start[1], 0);
// var endDate = new Date(0, 0, 0, end[1], end[1], 0);
// var diff = endDate.getTime() - startDate.getTime();
// var hours = Math.floor(diff / 1000 / 60 / 60);
// diff -= hours * 1000 * 60 * 60;
// var minutes = Math.floor(diff / 1000 / 60);
// console.log('minutes difference', hours + ":"  + minutes)
// if((hours + ":"  + minutes) > "0:30"){
//   console.log('blinkOfflineHotel true')
//   this.blinkOfflineHotel = true
//   // return heartBeatData
// }else{
//   console.log('blinkOfflineHotel false')
//   this.blinkOfflineHotel = false
//   // return heartBeatData
// } 
// return heartBeatData
  }

  GetParseonlyDateTime(d:any) {
    console.log('GetParseonlyDateTime call',d)
    if (d == "") {
      return "";
    }
    console.log(d.substring(4, 7))
    return (d.substring(4, 7));
  }
  // GetParseonlyDateTimeHeartbeat(d:any) {
  //   console.log('GetParseonlyDateTimeHeartbeat',d)
  //   if (d == "") {
  //     return "";
  //   }
  //   console.log('GetParseonlyDateTimeHeartbeat = ',d.substring(0, 2))
  //   return (d.substring(0, 2));
  // }

  GetParseonlyDateTimeHeartbeat(d:any) {
    var dt1 = new Date(d);
    var dt2 = new Date();
    // console.log('dt1 = ',dt1)
    // console.log('dt2 = ',dt2)
    var diff =(dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    // console.log('Math ABS = ',Math.abs(Math.round(diff)));
    if(Math.abs(Math.round(diff)) > 60){
      return false
    }else{
      return true
    }
      }

  diff_minutes(dt2, dt1) 
 {
  console.log('dt2.getTime() = ',dt2)
  console.log('dt1.getTime() = ',dt1)
  var diff =(dt2.getTime() - dt1.getTime()) / 1000;
  diff /= 60;
  return Math.abs(Math.round(diff));
  
 }
  GetHeartbeatTime(d:any) {
    console.log('GetHeartbeatTime call = ',d.substring(12))
    return (d.substring(12));
  }

  callIDSUsersProperties() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.apiCallForIdsProductsService.getQatarSync()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          if(data.length > 0){
            this.filterProperty = data
            this.idsProductList = data;
            console.log(this.dataSource)
            this.dataSource = new MatTableDataSource(this.idsProductList);
            this.dataSource.paginator = this.paginator;
            this.errorMsgSubscription = false
                this.displayContent = true
          console.log(this.totalcount)
          this.toastr.success('Data loaded Successfully');
          this.isProgressing = false
          }else{
            this.displayContent = false
          this.errorMsgSubscription = true
          this.errorMessage = "No Data Found"
          this.toastr.error('No Data Found');
          this.isProgressing = false;
          }
        });
        
        
  }

  showError(pmscode:any,pmsname:any){
    console.log("Error Data =", pmscode)
    this.pmscode = pmscode
    this.pmsname = pmsname
    this.displayErrorContent = true
    this.displayContent = false
    this.isProgressing = true
    this.apiCallForIdsProductsService.getQatarSyncError(pmscode)
    .subscribe(
      data => {
        console.log('Error Data Response =', data)
        this.idsProductList = data;
        this.dataSource1 = new MatTableDataSource(this.idsProductList);
        this.dataSource1.paginator = this.paginator;
        this.isProgressing = false
      });
  }

  backBtn() {
    this.isProgressing = true;
    this.displayErrorContent = false
    this.callIDSUsersProperties();
    this.displayContent = true
  }

  Search(event:any) {
    console.log('event= ', event)
    this.dataSource = this.filterProperty.filter((res: { hotelName: { toString: () => string; }}) => {
      return res.hotelName.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase())
    });
    if(event == ''){
      this.Val = '';
    }
  }


  getDimensionsByFilter(propertyCode:any){
    console.log('dropdownDeptData =',this.dropdownDeptData)
    return this.dropdownDeptData.filter((x: { propertyCode: any; }) => x.propertyCode === propertyCode);
  }

  closeModalDialog() {
    this.display = false; //set none css after close dialog
  }
  changePropertySearch() {
    // console.log('selectedDeptItems = ',this.selectedDeptItems)
    if (this.selectedDeptItems) {
      if (this.selectedDeptItems.length > 0) {
        console.log('if condition')
        console.log('selectedDeptItems = ', this.selectedDeptItems)
        this.errorMsgSubscription = true
        this.errorMessage = "Loading......."
        this.displayContent = false
        this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
        console.log('pms code value = ', this.Pmscodevalue)

      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        this.errorMessage = "Loading......."
        this.displayContent = false
      }
    } else {
      console.log('Property Not Selected')
    }
  }

  pageEvent(e) {
    console.log(e)
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  } 

  showXml(xmltype: any, token: any) {
    console.log('xmltype =',xmltype)
    console.log('token =',token)
    this.XMLstatus = this.LoadXML(xmltype, token);
  }

  LoadXML(xmltype: any, token: any) {
    console.log("LoadXML");
    this.isProgressing = true;
    if (xmltype == "RequestJSON") {
      console.log(xmltype);
      const xml = beautify(token);
      this.XMLName = "Request JSON"
      this.defaultData = xml;
      this.display = true;
      this.isProgressing = false;
    }else if (xmltype == "ResponseJSON") {
      console.log(xmltype);
      const xml = beautify(token);
      console.log(xml);
      this.XMLName = "ResponseJSON"
      this.defaultData = xml;
      this.display = true;
      this.isProgressing = false;
    }
  }

}